import AdminAttrib from '@/generated/classes/AdminAttrib';
export default class AdminAttribExtend extends AdminAttrib {

  public key: string;
  public title: string;
  public sortable: boolean;


  constructor() {
    super();
  }
}
